import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';

import createSagaMiddleware from 'redux-saga';
import { all } from '@redux-saga/core/effects';

// Slices
import userSlice from './slices/user';
import appSlice from './slices/app';
// Sagas
import { UserSagas } from './sagas/user';
import { AppSagas } from './sagas/app';

export type AppState = ReturnType<typeof store.getState>;

const sagaMiddleware = createSagaMiddleware();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const convertSagaArray = (sagas: any[]) => {
  if (Array.isArray(sagas))
    return function* rootSaga() {
      yield all(sagas);
    };
  return sagas;
};

// Create our store
export const store = configureStore({
  reducer: { app: appSlice.reducer, user: userSlice.reducer },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore all actions that redux-persist has
        // https://redux-toolkit.js.org/usage/usage-guide#use-with-redux-persist
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
        ignoreState: true,
      },
      immutableCheck: false,
    }).concat(sagaMiddleware),
});

const sagas = [...UserSagas, ...AppSagas];
sagaMiddleware.run(convertSagaArray(sagas));

export const persistor = persistStore(store);
